export const ERP_LOGIN_URL =
  process.env.NEXT_PUBLIC_ERP_LOGIN_URL || 'https://erp.famefusion.agency/login'
